import React from 'react';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../Widget/ControllerContext';
import {TPAComponentsProvider} from '@wix/wix-ui-tpa/cssVars';
import {getDirValue} from '../../../domain/utils/getDirValue';
import {pageTheme} from '../../../common/components/WithThemeOverride/pageTheme';
import {getBrandStyle} from '../../../common/components/WithThemeOverride/brandStyle';
import {LoadingLayout} from './LoadingLayout';
import {LoadedLayoutLazy} from './LoadedLayoutLazy';
import {SkipCheckoutLayout} from '../SkipCheckoutLayout/SkipCheckoutLayout';
import {SkipCheckoutFlowStatus} from '../../../types/checkoutApp.types';

export enum CheckoutAppPageDataHook {
  root = 'CheckoutAppPageDataHook.root',
}

const CheckoutApp = () => {
  const {isLoading, isOneColumnView, skipCheckoutFlowStatus, failedToFetch, loadingStateEcommerceSettingsStore} =
    useControllerProps();
  const {isRTL, isMobile} = useEnvironment();
  const rootStyle = {
    ...pageTheme,
    ...getBrandStyle(loadingStateEcommerceSettingsStore?.loadingStateEcommerceSettings?.checkoutSettings.checkoutBrand),
  };

  const loadingLayout = <LoadingLayout isOneColumnView={isOneColumnView} />;
  const loadedLayout = <LoadedLayoutLazy fallback={loadingLayout} loaded={!isLoading} />;

  const renderMainContent = () => {
    if (failedToFetch) {
      return loadedLayout;
    }
    if (skipCheckoutFlowStatus === SkipCheckoutFlowStatus.CheckingEligibility) {
      return <SkipCheckoutLayout status={SkipCheckoutFlowStatus.CheckingEligibility} />;
    }
    if (skipCheckoutFlowStatus === SkipCheckoutFlowStatus.PlacingOrder) {
      return <SkipCheckoutLayout status={SkipCheckoutFlowStatus.PlacingOrder} />;
    }
    if (isLoading) {
      return loadingLayout;
    }
    return loadedLayout;
  };

  return (
    <div
      data-hook={CheckoutAppPageDataHook.root}
      style={rootStyle}
      className={isMobile ? 'mobile-view' : undefined}
      dir={getDirValue(isRTL)}>
      <TPAComponentsProvider value={{rtl: isRTL}}>{renderMainContent()}</TPAComponentsProvider>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default CheckoutApp;
